import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'

import { FunctionModal } from 'components/common/Modal'
import TagList from './TagList'

const FilterModal = ({
  open,
  tagCategories,
  defaultFilters,
  onClose,
  onConfirm,
}) => {
  const [filters, setFilters] = useState(defaultFilters || [])
  useEffect(() => {
    if (open && filters !== defaultFilters) {
      setFilters(defaultFilters || [])
    }
  }, [open])

  const closeModal = () => {
    setFilters(defaultFilters || [])
    onClose()
  }
  const onConfirmClick = () => {
    onConfirm(filters)
    closeModal()
  }

  return (
    <FunctionModal open={open} onClose={onClose} autoHeight={true}>
      <Box display="flex" flexDirection="column" height="100%">
        <Box flexGrow={1} px={4} py={2} overflow="auto">
          {tagCategories?.map((category) => (
            <Box key={category._id}>
              <Typography>
                <Box fontWeight="fontWeightBold" py={6}>
                  {category.name}
                </Box>
              </Typography>
              <TagList
                category={category}
                filters={filters}
                onChange={setFilters}
              />
            </Box>
          ))}
        </Box>

        <Box p={5}>
          <Grid container spacing={3} justifyContent="flex-end">
            <Grid item xs={6} lg={3}>
              <Button
                variant="outlined"
                size="small"
                fullWidth
                onClick={closeModal}
              >
                取消
              </Button>
            </Grid>
            <Grid item xs={6} lg={3}>
              <Button
                size="small"
                variant="contained"
                color="primary"
                fullWidth
                onClick={onConfirmClick}
              >
                確認
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </FunctionModal>
  )
}

FilterModal.defaultProps = {
  defaultFilters: [],
  tagCategories: [],
}

export default FilterModal
